/* Playback control for [data-pxv-auto] videos rendered by snippets/pexar-video-media.
   Loaded once per page - the snippet emits the same <script src> for every video it
   renders and the guard below makes the extra executions no-ops.

   Why not the `autoplay` attribute:
     - the hidden half of a desktop/mobile pair still fetches and decodes under it;
     - an offscreen video keeps running for the whole length of the page;
     - it cannot be walked back for prefers-reduced-motion, which is a real
       accessibility problem for autoplaying motion, not a nicety. */
(function () {
  if (window.__pxvInit) return;
  window.__pxvInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen = [];
  var io = null;

  /* offsetParent is null for a display:none element, which is exactly how the CSS
     hides the wrong half of a pair. Cheaper and more direct than re-reading the
     media query the stylesheet already answered. */
  function laidOut(v) {
    return v.offsetParent !== null;
  }

  function apply(v) {
    if (v.__pxvIn && laidOut(v)) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } else if (!v.paused) {
      v.pause();
    }
  }

  function observer() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        entries[i].target.__pxvIn = entries[i].isIntersecting;
        apply(entries[i].target);
      }
    }, { rootMargin: '150px 0px' });
    return io;
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('video.pxv[data-pxv-auto]');
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.__pxvSeen) continue;
      v.__pxvSeen = true;

      /* Reduced motion: no playback, and controls so the video is still reachable.
         Setting .muted in script as well as in markup - the attribute alone has been
         known not to satisfy the autoplay policy when play() is called from JS. */
      if (reduce) {
        v.controls = true;
        continue;
      }
      v.muted = true;
      seen.push(v);

      var o = observer();
      if (o) {
        o.observe(v);
      } else {
        v.__pxvIn = true;
        apply(v);
      }
    }
  }

  /* A resize can swap which half of a pair is laid out without changing anything the
     IntersectionObserver watches, so it would never fire and both halves would be
     left as they were - one playing while hidden, one paused while visible. */
  function recheck() {
    for (var i = 0; i < seen.length; i++) apply(seen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  window.addEventListener('resize', recheck);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
